import React from 'react';
import ModalComponent from 'react-modal';
import './modal.ui.scss';
ModalComponent.setAppElement('#root');

interface IModalProps {
    isOpen:boolean;
    children: React.ReactNode;
    customStyles?: React.CSSProperties;
    onClose?: () => void;
}

const Modal = (props:IModalProps) => {
    const defaultStyles = {
        content: {
            border: "none",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: '0px',
            marginRight: '-50%',
            borderRadius: '8px',
            transform: 'translate(-50%, -50%)',
            ...props.customStyles
        },
    };
    return (
        <ModalComponent
            isOpen={props.isOpen}
            style={defaultStyles}
            overlayClassName="modal-overlay"
            onRequestClose={props.onClose}
            shouldCloseOnOverlayClick={!!props.onClose}
        >
            {props.children}
        </ModalComponent>
    )
}

export default Modal;